"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PopoverDropdown;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function PopoverDropdown(props) {
  var sections = props.sections,
    handleClick = props.handleClick,
    anchorElement = props.anchorElement,
    setAnchorElement = props.setAnchorElement,
    itemRenderer = props.itemRenderer,
    menuAlign = props.menuAlign;
  var theme = (0, _material.useTheme)();
  var handleClose = function handleClose() {
    setAnchorElement(null);
  };
  var _onClick = function onClick(item) {
    if (item.onClick) {
      item.onClick();
    }
    handleClick(item);
  };
  var itemStyles = function itemStyles(type) {
    return {
      color: type === 'destructive' ? theme.palette.TwClrTxtDanger : theme.palette.TwClrTxt,
      '& .MuiMenuItem-root:hover': {
        backgroundColor: theme.palette.TwClrBgSelectedGhostHover
      },
      '&.MuiMenuItem-root:active': {
        backgroundColor: theme.palette.TwClrBgSelectedGhostActive
      }
    };
  };
  return /*#__PURE__*/_react.default.createElement(_material.Popover, {
    id: "simple-popover",
    open: Boolean(anchorElement),
    anchorEl: anchorElement,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: menuAlign !== null && menuAlign !== void 0 ? menuAlign : 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: menuAlign !== null && menuAlign !== void 0 ? menuAlign : 'left'
    },
    sx: {
      '& .MuiPaper-root': {
        borderRadius: '8px',
        boxShadow: 'none',
        border: "1px solid ".concat(theme.palette.TwClrBrdrSecondary),
        paddingY: '8px',
        marginTop: '4px'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.MenuList, {
    sx: {
      padding: 0
    }
  }, sections === null || sections === void 0 ? void 0 : sections.map(function (section, index) {
    var elements = [];
    if (index > 0) {
      elements.push( /*#__PURE__*/_react.default.createElement(_material.ListItem, null, "---"));
    }
    elements = [].concat((0, _toConsumableArray2.default)(elements), (0, _toConsumableArray2.default)(section.map(function (item, itemIndex) {
      return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
        onClick: function onClick() {
          return _onClick(item);
        },
        key: "option-".concat(itemIndex),
        sx: itemStyles(item.type),
        disableRipple: true
      }, itemRenderer ? itemRenderer(item) : item.label);
    })));
    return elements;
  })));
}